import Campuses from "../constants/campus.json";

function Footer() {
  return (
    <footer className="dark-footer">
			<div className="container">
				<div className="row">
					{Object.values(Campuses).map((campus) => (
						<div key={campus.name} className="col-lg-4 col-md-4 px-4">
							<div className="footer-widget text-center">
								<h4 className="widget-title mb-2">{campus.name}</h4>
								<a className="align-items-center footer-link" target="_blank" rel="noreferrer"
									href={campus.location.map}>
									<div className="my-3">
										<i className="bi bi-geo pe-2" style={{ color: "var(--redcolor)" }}></i>
										{campus.location.address}
									</div>
								</a>
								<a className="align-items-center footer-link gap-2 my-3" href={campus.contact.phoneHref}
									target="_blank" rel="noreferrer">
									<div className="d-flex justify-content-center">
										<div className="square--30 circle bg-light-main text-main">
											<i className="bi bi-telephone"></i>
										</div>
										<div className="fs-6 fw-semibold">{campus.contact.phone}</div>
									</div>
								</a>
								<a className="align-items-center footer-link gap-2 my-3" href={campus.contact.whatsappHref}
									target="_blank" rel="noreferrer">
									<div className="d-flex justify-content-center">
										<div className="square--30 circle bg-light-main text-main">
											<i className="bi bi-whatsapp"></i>
										</div>
										<div className="fs-6 fw-semibold">{campus.contact.whatsapp}</div>
									</div>
								</a>
							</div>
						</div>
					))}

					<div className="footer-bottom">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-8">
									<p className="mb-0">© 2026  IUTA Puerto La Cruz</p>
								</div>

								<div className="col-4 text-end">
									<ul className="footer-bottom-social">
										<li>
											<a href="https://www.instagram.com/iutapuertolacruzoficial/" target="_blank" rel="noreferrer">
												<i className="ti-instagram"></i>
											</a>
										</li>
										<li>
											<a href="mailto:contacto@iutaplc.edu.ve" target="_blank" rel="noreferrer">
												<i className="ti-email"></i>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
  );
}

export default Footer;
